import { IUserProfilePicture } from '../interfaces/user-profile-picture.interface';

export class Avatar {
    public src: string;

    constructor(profilePicture?: IUserProfilePicture) {
        this.src = profilePicture ? profilePicture.thumb_url : '';
    }
}
